import { render } from "./OrganisationContracts.vue?vue&type=template&id=85358ec8"
import script from "./OrganisationContracts.vue?vue&type=script&lang=js"
export * from "./OrganisationContracts.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__